// import LoginModal from '../components/login-modal.svelte'
const Slideout = require('../js/lib/slideout')
import BigPicture from 'bigpicture'
import { getJquery } from '../js/util'
import plausible from '../js/lib/plausible'

const { boostPopupOptions } = window

let $ = getJquery()

export default {
	init() {
		const $body = $('body')

		var slideout = new Slideout({
			panel: document.getElementById('panel'),
			menu: document.getElementById('menu'),
			padding: 256,
			tolerance: 70,
		})

		// toggle navigation w/ icon
		$('#toggle_nav').on('click', function (e) {
			e.preventDefault()
			slideout.toggle()
		})

		$(document).on(
			'click',
			'.menu-section .menu-item-has-children > a',
			function (e) {
				e.preventDefault()
				let $el = $(this)
				$el.parent().toggleClass('show-subnav')
			}
		)

		// search toggle
		$body.on('click', '[data-search-toggle]', function (e) {
			e.preventDefault()
			if ($body.hasClass('show-search')) {
				$body.removeClass('show-search')
			} else {
				$body.addClass('show-search')
				setTimeout(() => {
					$('#site_search')[0].focus()
				}, 50)
			}
		})

		if ($body.hasClass('page-template-videos')) {
			$('.polaroid a').on('click', function (e) {
				e.preventDefault()
				if ($body.hasClass('logged-in')) {
					BigPicture({
						el: this,
						ytSrc: $(this).attr('data-ytsrc'),
					})
				} else {
					window.swal(
						'Restricted',
						'Please log in to view video tutorials',
						'error'
					)
				}
			})
		}

		//quick add to cart
		const $quickAddToCart = $('.quick-add-to-cart')
		if ($quickAddToCart.length) {
			modalEvents()
			$quickAddToCart.on('click', function (e) {
				e.preventDefault()
				const $this = $(this)
				const productID = $this.attr('data-id')
				let $container = $this.closest('.product-grid-item')
				if (!$container.length) {
					$container = $this.closest('.featured-products-slider')
				}
				$container.block({
					message: '',
					overlayCSS: {
						backgroundColor: '#fff',
					},
				})
				$.ajax({
					type: 'post',
					url: `${$('.logo-link').attr('href')}/wp-admin/admin-ajax.php`,
					data: {
						product_id: productID,
						action: 'bodycommerce_ajax_add_to_cart_woo_single',
					},
					success: function (res) {
						if (res.fragments) {
							const imgSrc = $('.attachment-shop_single.wp-post-image').attr(
								'src'
							)
							const $modal = $(res.fragments['product-modal'])
							$('span.cart-count')[0].outerHTML =
								res.fragments['span.cart-count']
							$modal.find('img').attr('src', imgSrc)
							$body.append($modal)
						}
					},
					complete: function () {
						$container.unblock()
					},
				})
			})
		}
		function modalEvents() {
			// modal close
			$body.on('click', '.modal-overlay', function (e) {
				var $target = $(e.target)
				if (
					!$target.hasClass('close-modal') &&
					$target.closest('.modal').length
				) {
					return
				}
				this.className = this.className + ' close-modal'
				window.setTimeout(function () {
					var overlay = $target.hasClass('modal-overlay')
						? e.target
						: $('.modal-overlay')[0]
					$body[0].removeChild(overlay)
				}, 300)
			})
		}
	},
	finalize() {
		//login modal
		// if (window.login_form_object) {
		// 	new LoginModal({
		// 		target: document.body,
		// 		props: {
		// 			loginLinks: $('#login, .please-login a:first-of-type'),
		// 			registerLinks: $('.register-link, .please-login a:last-of-type'),
		// 			loginLinksMobile: $('#menu-mobile-menu > .login > a'),
		// 			options: boostPopupOptions,
		// 		},
		// 	})
		// }

		plausible()

		analyticsBullshit()

		let $loginLinks = $('#login, .please-login a:first-of-type, #mobileLogin')
		let $registerLinks = $(
			'.register-link, .please-login a:last-of-type, #mobileRegister'
		)

		let $phpLoginModal = $('#phpLoginModal')
		if ($phpLoginModal.length) {
			let $phpRegistrationModalWrap = $('#phpRegistrationModalWrap')
			let $phpLoginModalWrap = $('#phpLoginModalWrap')
			let $phpModalInner = $('#phpModalInner')

			let regHeight = Math.max(870, $phpRegistrationModalWrap.height())
			let logHeight = Math.max(430, $phpLoginModalWrap.height())

			function focusFieldRegister() {
				$(
					'#phpRegistrationModalWrap .modal-body .gform_wrapper .gform-body > .gform_fields .gfield:first-child .ginput_container input'
				).focus()
			}
			function focusFieldLogin() {
				$('#phpLoginModalWrap #input_1').focus()
			}

			//show modal
			function showModal() {
				$phpLoginModal.addClass('phpLoginModalReveal')
				document.documentElement.style.overflowY = 'hidden'
			}
			function hideModal() {
				$phpLoginModal.removeClass('phpLoginModalReveal')
				document.documentElement.style.overflowY = 'auto'
				hideModalLogin()
				hideModalRegistration()
			}
			function showModalRegistration() {
				$phpRegistrationModalWrap.addClass('phpLoginModalReveal')
				regHeight = Math.max(870, $phpRegistrationModalWrap.height())
				$phpModalInner.css('height', regHeight)
				focusFieldRegister()
			}
			function hideModalRegistration() {
				$phpRegistrationModalWrap.removeClass('phpLoginModalReveal')
			}
			function showModalLogin() {
				$phpLoginModalWrap.addClass('phpLoginModalReveal')
				logHeight = Math.max(430, $phpLoginModalWrap.height())
				$phpModalInner.css('height', logHeight)
				focusFieldLogin()
			}
			function hideModalLogin() {
				$phpLoginModalWrap.removeClass('phpLoginModalReveal')
			}

			//register reveal
			$registerLinks.on('click', function (e) {
				e.preventDefault()
				showModal()
				showModalRegistration()
				focusFieldRegister()
			})

			//hide modal
			document.body.addEventListener('keyup', function (e) {
				if (e.key === 'Escape') {
					hideModal()
				}
			})
			let $phpLoginModalClose = $('#phpModalInner .close-modal')
			$phpLoginModalClose.on('click', function () {
				hideModal()
			})
			$phpLoginModal.on('click', function (e) {
				if (e.target === e.currentTarget) {
					hideModal()
				}
			})

			//switch states
			let $loginStateToggle = $('#loginStateToggle')
			let $registerStateToggle = $('#registerStateToggle')
			$registerStateToggle.on('click', function () {
				showModalRegistration()
				hideModalLogin()
			})
			$loginStateToggle.on('click', function () {
				showModalLogin()
				hideModalRegistration()
			})

			//login reveal
			$loginLinks.on('click', function (e) {
				e.preventDefault()
				showModal()
				hideModalRegistration()
				showModalLogin()
			})

			//spinner
			let $registerSubmitBtnWrap = $('#phpRegistrationModalWrap .gform_footer')
			let $registerCustomSpinner = $('#phpRegistrationModalWrap #customSpinner')
			let $loginSubmitBtnWrap = $('#phpLoginModalWrap .gform_footer')
			let $loginCustomSpinner = $('#phpLoginModalWrap #customSpinner2')
			$(document).ready(function () {
				//append buttons into submit wrappers on document load
				// console.log('ready')
				$registerSubmitBtnWrap.prepend($registerCustomSpinner)
				$loginSubmitBtnWrap.prepend($loginCustomSpinner)
			})

			let $registerSubmitBtn = $('#phpRegistrationModalWrap input[type=submit]')
			$registerSubmitBtn.on('click', function (e) {
				//add spinning animation on submit click
				// e.preventDefault()
				$registerCustomSpinner.addClass('reveal-custom-spinner')
				$registerSubmitBtn.addClass('fade-submit')
			})

			let $loginSubmitBtn = $('#phpLoginModalWrap input[type=submit]')
			$loginSubmitBtn.on('click', function (e) {
				//add spinning animation on submit click
				// e.preventDefault()
				$loginCustomSpinner.addClass('reveal-custom-spinner')
				$loginSubmitBtn.addClass('fade-submit')
			})

			$('#loginStateToggle, #registerStateToggle').on('click', function () {
				//remove animations when toggling states
				$registerCustomSpinner.removeClass('reveal-custom-spinner')
				$registerSubmitBtn.removeClass('fade-submit')
				$loginCustomSpinner.removeClass('reveal-custom-spinner')
				$loginSubmitBtn.removeClass('fade-submit')
			})

			//error logic
			let $error_msg = $('#phpLoginModal .gfield_validation_message')
			if ($error_msg.length) {
				//if error on login form, show form on reload
				showModal()
				showModalLogin()
			}
		}
	},
}

function analyticsBullshit() {
	let { $ } = window
	if (!$) {
		$ = window.jQuery
	}
	// send user registration event when form is submitted
	$(document).on('gform_confirmation_loaded', function (event, formId) {
		if (formId == 35) {
			// run code specific to form ID 1
			window?.gtag('event', 'user_registration', {
				event_category: 'user_registration',
				event_label: 'user_registration',
			})
		}
	})
}
